import React from 'react'

import { Card, CardContent, CardHeader } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { UrlProvider } from 'urls'

import LoadingView from 'components/LoadingView'
import { UserEditForm } from 'components/user'
import { useAddNotification } from 'hooks/useAddNotification'
import { useUpdateUser } from 'hooks/useUpdateUser'
import { useUser } from 'hooks/useUser'

const UserEdit = () => {
  const { id } = useParams()
  const { data: user, isLoading, error } = useUser(id)
  const { mutate: updateUser } = useUpdateUser()
  const addNotification = useAddNotification()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleSubmit = (values: any) => {
    updateUser(
      { userId: id, values },
      {
        onSuccess: () => {
          addNotification('User updated successfully', 'success')
          queryClient.invalidateQueries({ queryKey: ['user', id] })
          navigate(UrlProvider.getUrl('user', { id }))
        },
        onError: () => addNotification('Error occurred when updating user data', 'error'),
      },
    )
  }

  return (
    <Card>
      <CardHeader title="User Edit" />
      <CardContent>
        <LoadingView error={error ? 'Error occurred when loading user data' : ''} loading={isLoading}>
          <UserEditForm id={user?.id} initialValues={user} onSubmit={handleSubmit} />
        </LoadingView>
      </CardContent>
    </Card>
  )
}

export default UserEdit
